import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/pip-exit.svg?react
const SvgPipExit = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	fill: "none",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	fill: "currentColor",
	d: "M160-160q-33 0-56.5-23.5T80-240v-280h80v280h640v-480H440v-80h360q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160zm523-140 57-57-124-123h104v-80H480v240h80v-103zM80-600v-200h280v200zm400 120"
}));

//#endregion
//#region src/icons/PipExitIcon.tsx
function PipExitIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgPipExit,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { PipExitIcon as t };
//# sourceMappingURL=PipExitIcon-DBi3s3yS.js.map